import {
  InformationCircleIcon,
  BugAntIcon,
  BeakerIcon,
  GlobeAltIcon,
  CubeIcon,
  CircleStackIcon,
  MusicalNoteIcon,
  HeartIcon,
  Square3Stack3DIcon,
  HashtagIcon,
  BoltIcon,
  SparklesIcon,
  TagIcon,
  CpuChipIcon
} from '@heroicons/react/24/outline';

const MAP = {
  gluten: Square3Stack3DIcon,
  crustaceans: BugAntIcon,
  eggs: CircleStackIcon,
  fish: GlobeAltIcon,
  peanuts: MusicalNoteIcon,
  soybeans: BeakerIcon,
  milk: HeartIcon,
  nuts: CubeIcon,
  sesame: HashtagIcon,
  mustard: TagIcon,
  celery: SparklesIcon,
  sulphites: BoltIcon,
  lupin: CpuChipIcon,
  molluscs: GlobeAltIcon
};

export const AllergenOutlineIcon = ({ keyName, className }) => {
  const Icon = MAP[keyName] || InformationCircleIcon;
  return <Icon className={className || 'allergen-outline-icon'} aria-hidden />;
};
